import banksReducer from "./reducers";
export { default as banksTypes } from "./types";
export { default as banksOperations } from "./operations";
export default banksReducer;
